import { gql } from "graphql-request";

export const CREATE_TENANT = gql`
  mutation CreateTenant($tenantData: CreateTenantInput!) {
    createTenant(tenantData: $tenantData) {
      data
    }
  }
`;

export const GET_ALL_TENANTS = gql`
  query GetAllTenants($pageNo: Int, $pageSize: Int, $searchKeyword: String) {
    getAllTenants(
      pageNo: $pageNo
      pageSize: $pageSize
      searchKeyword: $searchKeyword
    ) {
      meta {
        countDocs
        pageNo
        pageSize
      }
      data {
        companyName
        companyEmail
        businessAddress
        companyLogo
        tenantType
        _id
        isRestricted
        allowedPages
        users {
        _id
        firstName
        lastName
        email
      }
      }
    }
  }
`;



export const ENABLE_DISABLE_TENANT = gql`
  mutation EnableDisableTenant($tenantId: String!, $isRestricted: Boolean) {
    enableDisableTenant(tenantId: $tenantId, isRestricted: $isRestricted) {
      data
    }
  }
`;


export const DELETE_TENANT = gql`
  mutation DeleteTenant($tenantId: String!) {
    deleteTenant(tenantId: $tenantId) {
      data
    }
  }
`;



